import { createModelStore } from '@/shared/stores/create-model-store'
import { model12InitialModel } from './initial-state'
import { model12DimensionHandlers } from './dimensions'

export const useModel12Store = createModelStore({
  initialModel: model12InitialModel,
  dimensionHandlers: model12DimensionHandlers,
})
